<template>
    <section class="support-services-section" v-if="!loading && items.length > 0">
      <div class="text-center section-header">
        <h2 class="section-title">
          {{ $t("Support-Service") }}
        </h2>
        <p class="section-subtitle">
          {{ $t("Through_section") }}
        </p>
      </div>

      <div class="services-grid">
        <div
          class="service-card"
          v-for="(item, i) in items"
          :key="i"
          @click="providers(item.id)"
        >
          <div class="service-image-wrapper">
            <img :src="item.image" :alt="item.title" class="service-image">
            <div class="service-overlay"></div>
          </div>
          <p class="service-name">
            {{ item.title }}
          </p>
        </div>
      </div>
    </section>
    <v-row v-else>
      <template v-if="loading">
        <v-col cols="12" v-for="text in texts" :key="text">
          <v-skeleton-loader
            class="mx-auto border-0"
            type="paragraph"
          ></v-skeleton-loader>
        </v-col>
      </template>
      <template v-else>
        <v-col cols="12" class="d-flex justify-center align-center">
          <div class="no-services-card">
            <p class="no-services-text">{{ $t('no_services_now') }}</p>
          </div>
        </v-col>
      </template>
    </v-row>
</template>
<script>
import crudDataService from "@/Services/crudDataService";
export default {
  components: {},
  data() {
    return {
      items: [],
      texts: [1, 2, 3, 4, 5],
      loading: true,
    };
  },
  methods: {
    async service() {
      this.loading = true;
      try {
        let response = await crudDataService.getAll(`support-services?without=users`);
        this.items = response.data.data;
      } catch (e) {
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    providers(id) {
      this.$router.push({ name: "proviserservices", params: { id } });
    },
  },
  mounted() {
    this.service();
  },
};
</script>
<style>
.icon_service .v-img__img--contain {
  object-fit: none !important;
}
</style>
<style lang="scss" scoped>
.support-services-section {
  padding: 32px 0;
}

.section-header {
  margin-bottom: 40px;
}

.section-title {
  font-size: clamp(24px, 4vw, 32px);
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.section-subtitle {
  font-size: clamp(16px, 2.5vw, 20px);
  color: #666;
  font-weight: 400;
  margin: 0;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 24px;
  padding: 0;
}

.service-card {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 116, 199, 0.15);
    border-color: #0074c7;
    
    .service-image {
      transform: scale(1.05);
    }
    
    .service-overlay {
      background: rgba(0, 116, 199, 0.2);
    }
  }
}

.service-image-wrapper {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;
  background: #f5f5f5;
}

.service-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.service-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  transition: background 0.3s ease;
}

.service-name {
  padding: 16px;
  font-size: clamp(16px, 2vw, 18px);
  font-weight: 500;
  color: #333;
  text-align: center;
  margin: 0;
  line-height: 1.4;
}

.no-services-card {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 32px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
  border: 1px solid #e0e0e0;
}

.no-services-text {
  color: #666;
  font-size: clamp(18px, 3vw, 24px);
  font-weight: 500;
  margin: 0;
}

@media (max-width: 991.98px) {
  .services-grid {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 20px;
  }
  
  .service-image-wrapper {
    height: 160px;
  }
}

@media (max-width: 700px) {
  .services-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 16px;
  }
  
  .service-image-wrapper {
    height: 140px;
  }
  
  .section-header {
    margin-bottom: 32px;
  }
}

@media (max-width: 600px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  
  .service-image-wrapper {
    height: 120px;
  }
  
  .service-name {
    padding: 12px;
    font-size: 14px;
  }
  
  .support-services-section {
    padding: 24px 0;
  }
}

@media (max-width: 400px) {
  .services-grid {
    grid-template-columns: 1fr;
  }
}
</style>
